<template>
  <div class="page live-broadcast-coupon">
    <div class="header">
      <img src="../../assets/images/activity/form-verification-header.png">
      <img class="header-logo" src="../../assets/images/activity/form-verification-logo.png">
    </div>
    <div class="activity-img">
      <img class="activity-img-icon1" src="../../assets/images/activity/live-broadcast-icon1.png">
      <div>
        <img class="activity-img-icon2" src="../../assets/images/activity/live-broadcast-icon2.png">
      </div>
    </div>
    <div class="content">
      <div class="input-row">
        <van-field v-model="couponData.streamingPwd" center clearable placeholder="输入口令" input-align="center" @blur="viewDefault"/>
      </div>

      <div class="button-line" @click="submit">点 击 领 取</div>
      <div class="tips">
        <div>限量50张，领完即止！</div>
      </div>
    </div>

    <LiveBroadcastPop ref="liveBroadcastPop">
      <div slot="title">
        <span>{{ title }}</span>
        <div style="font-size: 16px;word-break: break-word">{{ coupon }}</div>
        <div class="qrCode" ref="qrCodeUrl"></div>
        <div style="color: #999; font-weight: 500; font-size: 14px; padding-top: 5px" v-html="message"></div>
      </div>
    </LiveBroadcastPop>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import LiveBroadcastPop from './components/live-broadcast-pop'
import { sessionStorageUtils } from '@/utils/sessionstorage'
import QRCode from 'qrcodejs2'
export default {
  name: 'LiveBroadcastCoupon',
  components: {
    LiveBroadcastPop
  },
  data () {
    return {
      couponData: {
        streamingCode: 'streaming200612',
        streamingPwd: ''
      },
      message: '',
      title: '',
      coupon: '',
      hasBtn: false,
      qrcode: null
    }
  },
  methods: {
    submit () {
      this.hasBtn = false
      if (!this.couponData.streamingPwd) {
        this.$toast({ message: '请输入口令' })
        return false
      }
      if (this.couponData.streamingPwd.toUpperCase() !== 'BTD大卖') {
        this.$toast({ message: '口令错误' })
        return false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载中...'
      })
      const wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
      const params = Object.assign({}, this.couponData, { wxOpenId: wxUserInfo.openId || '' })
      activityApi.liveBroadcastTakeCoupon(params).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          if (response.data.resultData.action === 'alreadyTook') {
            this.title = '您已领过优惠券哦！'
            this.coupon = '券码：' + response.data.resultData.giftCode
            this.message = '请截图保存作为后续核销凭证'
            this.$refs['liveBroadcastPop'].popShow = true
            this.$nextTick(() => {
              this.creatQrCode(response.data.resultData.giftCode)
            })
          } else if (response.data.resultData.action === 'overLimit') {
            this.title = '抱歉，优惠券已领完'
            this.message = '关注易加网，了解更多优惠活动'
          } else {
            this.title = '恭喜您，领取成功！'
            this.coupon = '券码：' + response.data.resultData.giftCode
            this.message = '请截图保存作为后续核销凭证'
            this.$refs['liveBroadcastPop'].popShow = true
            this.$nextTick(() => {
              this.creatQrCode(response.data.resultData.giftCode)
            })
          }
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    creatQrCode (code) {
      if (this.qrcode) {
        return
      }
      this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: code, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    viewDefault () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100vh);
  padding-top: 0;
  background: #fff;
}
.header {
  position: relative;
  img {
    width: 100%;
  }
  .header-logo {
    position: absolute;
    top: 0;
    left: 10px;
    width: 30px;
  }
}
.activity-img {
  width: 100%;
  height: 160px;
  padding-top: 50px;
  text-align: center;
  .activity-img-icon1 {
    width: 80%;
  }
  .activity-img-icon2 {
    width: 50px;
  }
}
.subject {
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-size: 22px;
  width: 30%;
  // line-height: 34px;
  font-weight: 700;
  color: rgb(52, 122, 127);
  margin: 0 auto;
  margin-bottom: 30px;
  padding-bottom: 5px;
  background: url('../../assets/images/activity/form-verification-desc.png') bottom no-repeat;
  background-size: 95% auto;
  // &:nth-child(1) {

  // }
}
.content {
  width: 80%;
  margin: 30px auto 0 auto;
}
.input-row {
  position: relative;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 5px 0;
  margin-bottom: 20px;
  .icon-input {
    position: absolute;
    z-index: 10;
    top: 10px;
  }
  .icon-user {
    left: 10px;
    width: 12px;
    height: 17px;
    img {
      width: 12px;
      height: 17px;
    }
  }
  .icon-pwd {
    left: 10px;
    width: 13px;
    height: 15px;
    img {
      width: 13px;
      height: 15px;
    }
  }
  .icon-right {
    top: 14px;
    right: 10px;
    .pwd-hide {
      width: 18px;
      height: 8px;
    }
    .pwd-show {
      width: 16px;
      height: 10px;
    }
  }
  .van-cell {
    height: 60px;
    text-align: center;
    // padding-left: 36px;
    font-size: 20px;
  }
  .pwd-cell {
    padding-right: 36px;
  }
  ::-webkit-input-placeholder{
    color: #ccc;
  }
}
.info {
  text-align: center;
  color: rgb(166, 166, 166);
}
.button-line {
  width: 200px;
  height: 40px;
  margin: 50px auto 5px auto;
  line-height: 40px;
  border-radius: 20px;
  background-image: linear-gradient(to right, rgba(52, 122, 127, .8), rgba(52, 122, 127, 1));
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.operate {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: rgb(166, 166, 166);
}
.tips {
  padding: 22px 0;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  color: rgb(52, 122, 127);
}

.van-popup {
  width: 270px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0);
  .pop-content {
    background: url("../../assets/images/activity/form-verification-header2.png") top no-repeat;
    background-size: 100% auto;
    padding: 30px 5px;
    text-align: center;
    border-radius: 10px;
    background-color: #fff;
    .pop-content-img {
      position: relative;
      width: 100px;
      padding-top: 20px;
      margin: 20px auto;
      img {
        width: 100%;
        height: 100%;
      }
      .pop-content-right {
        position: absolute;
        right: 0;
        bottom: 8px;
        width: 30px;
        height: 30px;
      }
    }
    .pop-content-title {
      // font-weight: bold;
      line-height: 40px;
      font-size: 20px;
    }
    .pop-content-integral {
      line-height: 30px;
      font-size: 16px;
      color: #999;
    }
    .pop-content-btn {
      padding-top: 20px;
      .button-line {
        height: 35px;
        line-height: 35px;
        margin: 0 50px;
        font-weight: 400;
        background-color: rgba(52, 122, 127, 1);
      }
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 32px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.qrCode img{
  margin: auto;
}
</style>
